<template>
  <!-- end buttons area -->
  <div id="mySidenav" class="sidenav d-block" v-if="isSideBarActive">
    <div class="px-2" id="sidebar">
      <div class="filter-head mt-2 mb-4">
        <span class="filter-txt">Filter</span>
      </div>
      <div id="accordion" class="accordion-style mt-2">
        <div class="mb-3">
          <h5 class="mb-0 mtab">
            <div class="form-group ml-1">
              <label for="exampleFormControlInput1" class="font-10">Ersteller</label>
              <input type="text" v-on:input="filterByCreatorName" v-model="creatorName" class="form-control w-100 sm-input font1rem" id="exampleFormControlInput1" placeholder="Ersteller">
            </div>
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import {mapState} from 'vuex'
export default {
  props: ['searchString'],
  data () {
    return {
      creatorName: ''
    }
  },
  computed: {
    ...mapState({
      dateRangeFrom: state => state.photoDocumentation.dateRangeFrom,
      dateRangeTo: state => state.photoDocumentation.dateRangeTo,
      isSideBarActive: state => state.photoDocumentation.isSideBarActive,
    }),
  },
  methods: {
    async filterByCreatorName () {
      let dateFrom = moment(this.dateRangeFrom, 'DD.MM.YYYY').format('YYYY-MM-DD');
      let dateTo = moment(this.dateRangeTo, 'DD.MM.YYYY').format('YYYY-MM-DD');
      let filters = {
        _explicitType: "com\\projectdocu\\PredicateOperatorAndVO",
        operands:[]
      }
      let searchQry = {
        _explicitType: "com\\projectdocu\\PredicateOperandLikeVO",
        fieldname: "reportname", fieldvalue: `*${this.searchString}*`
      };
      let creator_filter = {
        _explicitType :"com\\projectdocu\\PredicateOperandLikeVO",
        fieldname :"creator", fieldvalue: `*${this.creatorName}*`
      }

      // filters.operands.push(date_filter);
      if (this.creatorName.length){
        filters.operands.push(creator_filter);
      }
      if (this.searchString.length){
        filters.operands.push(searchQry);
      }

      let orderQry = [
        {
          "_explicitType":"com\\projectdocu\\OrderSettingVO",
          "fieldname":"created",
          "order":"DESC"
        }
      ]
      console.log('Filters', filters)
      await this.$store.dispatch('getPhotoDocsList',[this.$route.params.id, 1150 , 0 , filters, orderQry] );
      this.$parent.currentPage = 1
    }

  },
  watch: {
    searchString: function (){
      this.filterByCreatorName();
    }
  }
}
</script>
<style scoped>
.sidenav {
  height: calc(100vh - 148px);
  left:0;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/SideNav.vue